export const TODO_PLUGIN_KEY = 'toDoItem';
export const TODO_TYPE = 'toDoItem';
